<div class="add-customer-vulnerability">
  <mat-card class="curtains">
    <div class="customer-vulnerability-header secondary-icon">
      <h5>Vulnerable Customer</h5>
      <div class="customer-panel">
        <button matIconButton (click)="confirmDeleteVulnerability()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <mat-card-content>
      <form [formGroup]="customerVulnerabilityForm">
        <div class="tow-fields">
          <mat-form-field>
            <mat-label>Customer Vulnerability</mat-label>
            <mat-select formControlName="customerVulnerability" required [disableOptionCentering]="true">
              @for (item of customerVulnerabilityList; track item) {
                <mat-option [value]="item">{{ item }}</mat-option>
              }
            </mat-select>
            @if (customerVulnerability.invalid) {
              <mat-error> Customer Vulnerability is <strong>required</strong> </mat-error>
            }
          </mat-form-field>
          @if (customerVulnerability.value === 'Customer Speaks') {
            <mat-form-field class="language-spoken">
              <mat-label>Language Spoken</mat-label>
              <mat-chip-grid #languageChipList formControlName="languagesSpoken" required>
                @for (language of languagesSpoken.value; track language) {
                  <mat-chip-row [removable]="true" (removed)="removeLanguage(language)">
                    {{ language | titlecase }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                }
                <input
                  matInput
                  autocomplete="off"
                  [matChipInputFor]="languageChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addLanguage($event)"
                  (blur)="addLanguage($event)" />
              </mat-chip-grid>
              @if (languagesSpoken.value.length === 0) {
                <mat-error>Language Spoken is <strong>required</strong></mat-error>
              }
            </mat-form-field>
          }
          @if (customerVulnerability.value === 'Other') {
            <mat-form-field>
              <mat-label>Details</mat-label>
              <input matInput autocomplete="off" formControlName="details" required />
              @if (details.invalid) {
                <mat-error>Details is <strong>required</strong></mat-error>
              }
            </mat-form-field>
          }
        </div>
        <div class="contact-info-container">
          <div class="title-1">Contact</div>
          <div class="info-message-container subtitle-2">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span>You may be contacted to provide further information on the vulnerability</span>
          </div>
        </div>
        <div class="three-fields">
          <mat-form-field>
            <mat-label>Contact Person</mat-label>
            <input matInput formControlName="contactPerson" required />
            @if (contactPerson.invalid) {
              <mat-error>Contact Person is <strong>required</strong></mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Position</mat-label>
            <input matInput formControlName="position" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phoneNumber" required />
            @if (phoneNumber.errors?.required) {
              <mat-error>Phone Number is <strong>required</strong></mat-error>
            }
            @if (phoneNumber.touched && phoneNumber.hasError('phoneInvalid')) {
              <mat-error> {{ getErrorMessage(phoneNumber.errors) }} </mat-error>
            }
          </mat-form-field>
        </div>
        <mat-form-field>
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" required />
          @if (email.errors?.required) {
            <mat-error>Email is <strong>required</strong></mat-error>
          }
          @if (email.errors?.pattern) {
            <mat-error>Invalid email format</mat-error>
          }
        </mat-form-field>
      </form>
    </mat-card-content>
  </mat-card>
</div>
